import { useNavigate } from "react-router-dom";
import { ScanLine } from "lucide-react";
import { Button } from "@shared/components/ui/button";

// F-AA: one tap from any visitor page to the next QR code — opens the
// scanner page with the camera already on (`?scan=1`).
export default function ScanNextButton({ t, className = "" }) {
  const navigate = useNavigate();
  return (
    <Button
      onClick={() => navigate("/qr-instructions?scan=1")}
      className={`w-full h-14 gap-3 text-xl font-bold bg-[#991B1B] text-white hover:bg-[#7F1D1D] ${className}`}
      data-testid="scan-next-button"
    >
      <ScanLine className="w-6 h-6" aria-hidden="true" />
      {t({ en: "Scan next", tc: "掃描下一個", sc: "扫描下一个" })}
    </Button>
  );
}
